export type StudentHelperResponseActionValue =
  | "continue"
  | "close_success"
  | "close_fail"
  | "close_teacher_abandon"
  | "close_student_abandon"
  | "close_error"

export interface StudentHelperResponseActionDTO {
  response_action: StudentHelperResponseActionValue
}

/**
 * Response actions that should cause student helper mode to end.
 */
const CLOSE_ACTIONS: ReadonlyArray<StudentHelperResponseActionValue> = [
  "close_success",
  "close_fail",
  "close_teacher_abandon",
] as const

export class StudentHelperResponseAction {
  constructor(public readonly value: StudentHelperResponseActionValue) {}

  isCloseAction(): boolean {
    return CLOSE_ACTIONS.includes(this.value)
  }

  static fromDTO(
    dto: StudentHelperResponseActionDTO,
  ): StudentHelperResponseAction {
    return new StudentHelperResponseAction(dto.response_action)
  }

  toDTO(): StudentHelperResponseActionDTO {
    return {
      response_action: this.value,
    }
  }
}
